import {getData} from "../api/get-data";


export const setItemError = (itemId, message = ``, resolveHandler, rejectHanlder) => {
  getData({
    [`set_item_error`]: {
      [`item_id`]: itemId,
      [`error_note`]: message,
    }
  })
  .then((response) => {
    if (response.result.toLowerCase() === `ok`) {
      resolveHandler(response);
    }

    rejectHanlder();
  });
};
